module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"CreareMondi.it","short_name":"CreareMondi.it","description":"Il blog del Fantasy","start_url":"/","background_color":"#ffffff","theme_color":"#000000","display":"standalone","icon":"src/images/crearemondi_webapp-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c2ff34ca6431caefa03a252e5b188412"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
